<div mat-dialog-title>
  <div class="row justify-content-end">
    <div class="col-10" style="color: #1d4f91; font-size: large; font-weight: 600;">
      Pedir mais detalhes das informações
    </div>
    <div class="col-2 text-right">
      <i
        mat-dialog-close
        role="button"
        class="fa fa-times"
        aria-hidden="true"
      ></i>
    </div>
  </div>
</div>

<div class="modal-body-title" id="modal-body-title" style="margin-right: 30px; margin-left: 30px;">
  <app-alert
    [hidden]="!successAlertActive"
    [titulo]="'Seu protocolo de solicitação de informação é o ' + nuPedido"
    [tipo]="'success'"
  >
    <p>
      Sua solicitação será atendida em até 15 dias e estará disponível para
      consulta e/ou impressão na página "Minhas Solicitações" em "Conheça seus
      Direitos".
    </p>
  </app-alert>

  <app-alert
    [hidden]="!errorAlertActive"
    [titulo]="'Houve um erro na solicitação'"
    [tipo]="'danger'"
  >
    <p>Por favor tente novamente mais tarde.</p>
  </app-alert>

  <app-alert
    *ngIf="missingFieldsAlertActive"
    [titulo]="'Campos obrigatórios'"
    [tipo]="'danger'"
  >
    <p>
      Por favor, é necessário selecionar o período de solicitação, ao menos uma
      finalidade, um motivo e um tipo de informação para solicitar o relatório.
    </p>
  </app-alert>

  <app-alert
    [hidden]="!missingFieldsAlertActiveDate"
    [titulo]="'Campos obrigatórios'"
    [tipo]="'danger'"
  >
    <p>
      Por favor, é necessário informar pelo menos um período máximo válido de 15
      anos até o momento para as informações solicitadas
    </p>
  </app-alert>
</div>

<mat-dialog-content class="modal-body mb-10" id="modal-body">
  <h6>Indique quais informações e o período que você deseja mais detalhes</h6>

  <div>
    <form [formGroup]="form">
      <m-expansion-panel [active]="true" [title]="'Período de solicitação'">
        <div class="description-section row">
          Informe um período para o detalhamento de suas informações
        </div>
        <div class="row">
          <div
            class="col-lg-3 col-md-5 col-xs-12 description-section"
            style="padding: 0px 15px 10px 0px"
          >
            <mat-form-field appearance="outline">
              <mat-label>De:</mat-label>
              <input
                spellcheck="false"
                [dropSpecialCharacters]="false"
                matInput
                type="text"
                placeholder="dd/mm/aaaa"
                formControlName="dataInicio"
                mask="00/00/0000"
              />
            </mat-form-field>
          </div>
          <div
            class="col-lg-3 col-md-5 col-xs-12 description-section"
            style="padding: 0px 15px 10px 0px"
          >
            <div
              style="color: red; float: left"
              *ngIf="missingFieldsAlertActive && form.controls.dataFim.invalid"
            >
              &nbsp;&nbsp;
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Até:</mat-label>
              <input
                spellcheck="false"
                [dropSpecialCharacters]="false"
                matInput
                type="text"
                placeholder="dd/mm/aaaa"
                formControlName="dataFim"
                mask="00/00/0000"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-6 col-md-2 col-sm-0"></div>
        </div>
      </m-expansion-panel>

      <mat-accordion id="accordion-motivoMarketing" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    formControlName="chkFinalidadeMarketing"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoMarketing');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-motivoMarketing"
                    #showMotivosMarketing
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong>Direcionamento de Ofertas</strong>
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeMarketing"
              ng-model="solicitarRelAnalitico.AtributosMarketing"
              class="form"
            >
              <div class="description-section row">
                Compartilhamos informações atualizadas e confiáveis para compor
                soluções e realizar análises de marketing, de forma a promover
                decisões estratégicas aos nossos clientes
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadeMarketing.valid &&
                      form.controls.motivoMarketing.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-finalidadeMarketing"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosMarketing"
                      #showAtributosMarketing
                      [disabled]="!form.controls.chkFinalidadeMarketing.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoMarketing')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivomarketing"
                        class="multiline-mat-option"
                        *ngFor="let motivomarketing of motivomarketingList"
                      >
                        {{ motivomarketing }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>
                <div
                  id="AtributosMarketing"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoMarketing.valid &&
                    form.controls.chkFinalidadeMarketing.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoMarketing"
                      *ngFor="
                        let atributoMarketing of form.get(
                          'chkAtributoMarketing'
                        )['controls'];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoMarketing-' +
                              atributomarketingList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributomarketingList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoMarketing.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <br />

      <mat-accordion id="accordion-finalidadeCredito" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    formControlName="chkFinalidadeCredito"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoCredito');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-finalidadeCredito"
                    #showMotivosCredito
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong>Proteção ao Crédito</strong>
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeCredito"
              ng-model="solicitarRelAnalitico.AtributosCredito"
              class="form"
            >
              <div class="description-section row">
                Compartilhamos informações atualizadas e confiáveis para compor
                soluções e realizar análises de marketing, de forma a promover
                decisões estratégicas aos nossos clientes
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadeMarketing.valid &&
                      form.controls.motivoMarketing.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-finalidadeCredito"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosCredito"
                      #showAtributosCredito
                      [disabled]="!form.controls.chkFinalidadeCredito.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoCredito')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivocredito"
                        class="multiline-mat-option"
                        *ngFor="let motivocredito of motivocreditoList"
                      >
                        {{ motivocredito }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>
                <div
                  id="AtributosCredito"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoCredito.valid &&
                    form.controls.chkFinalidadeCredito.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoCredito"
                      *ngFor="
                        let atributoCredito of form.get('chkAtributoCredito')[
                          'controls'
                        ];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoCredito-' + atributocreditoList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributocreditoList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoCredito.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <br />

      <mat-accordion id="accordion-dataQuality" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    #showMotivosDataQuality
                    formControlName="chkFinalidadeDataQuality"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoDataQuality');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-dataQuality"
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong>Aprimoramento da Qualidade de Dados</strong>
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeCredito"
              ng-model="solicitarRelAnalitico.AtributosCredito"
              class="form"
            >
              <div class="description-section row">
                Compartilhamos informações atualizadas e confiáveis para compor
                soluções e realizar análises de marketing, de forma a promover
                decisões estratégicas aos nossos clientes
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadeDataQuality.valid &&
                      form.controls.motivoDataQuality.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-dataQuality"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosDataQuality"
                      #showAtributosDataQuality
                      [disabled]="!form.controls.chkFinalidadeDataQuality.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoDataQuality')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivodataquality"
                        class="multiline-mat-option"
                        *ngFor="let motivodataquality of motivodataqualityList"
                      >
                        {{ motivodataquality }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>

                <div
                  id="AtributosDataQuality"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoDataQuality.valid &&
                    form.controls.chkFinalidadeDataQuality.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoDataQuality"
                      *ngFor="
                        let atributoDataQuality of form.get(
                          'chkAtributoDataQuality'
                        )['controls'];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoDataQuality-' +
                              atributodataqualityList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributodataqualityList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoDataQuality.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <br />

      <mat-accordion id="accordionPrevFraude" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    formControlName="chkFinalidadePrevFraude"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoPrevFraude');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-prevFraude"
                    #showMotivosPrevFraude
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong
                        >Identificação e Autenticação de indivíduos e Prevenção
                        a Fraude</strong
                      >
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeCredito"
              ng-model="solicitarRelAnalitico.AtributosCredito"
              class="form"
            >
              <div class="description-section row">
                Compartilhamos informações atualizadas e confiáveis para compor
                soluções e realizar análises de marketing, de forma a promover
                decisões estratégicas aos nossos clientes
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadePrevFraude.valid &&
                      form.controls.motivoPrevFraude.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-prevFraude"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosPrevFraude"
                      #showAtributosPrevFraude
                      [disabled]="!form.controls.chkFinalidadePrevFraude.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoPrevFraude')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivoprevfraude"
                        class="multiline-mat-option"
                        *ngFor="let motivoprevfraude of motivoprevfraudeList"
                      >
                        {{ motivoprevfraude }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>

                <div
                  id="AtributosPrevFraude"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoPrevFraude.valid &&
                    form.controls.chkFinalidadePrevFraude.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoPrevFraude"
                      *ngFor="
                        let atributoPrevFraude of form.get(
                          'chkAtributoPrevFraude'
                        )['controls'];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoPrevFraude-' +
                              atributoprevfraudeList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributoprevfraudeList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoPrevFraude.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <br />
      <mat-accordion id="accordionCertificado" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    formControlName="chkFinalidadeCertificado"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoCertificado');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-certificado"
                    #showMotivosCertificado
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong>Certificado Digital Serasa Experian</strong>
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeCertificado"
              ng-model="solicitarRelAnalitico.AtributosCertificado"
              class="form"
            >
              <div class="description-section row">
                Identificação eletrônica de uma pessoa para ter acesso a
                sistemas eletrônicos restritos e assinar documentos digitalmente
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadeCertificado.valid &&
                      form.controls.motivoCertificado.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-Certificado"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosCertificado"
                      #showAtributosCertificado
                      [disabled]="!form.controls.chkFinalidadeCertificado.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoCertificado')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivoCertificado"
                        class="multiline-mat-option"
                        *ngFor="let motivoCertificado of motivoCertificadoList"
                      >
                        {{ motivoCertificado }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>

                <div
                  id="AtributosCertificado"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoCertificado.valid &&
                    form.controls.chkFinalidadeCertificado.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoCertificado"
                      *ngFor="
                        let atributoCertificado of form.get(
                          'chkAtributoCertificado'
                        )['controls'];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoCertificado-' +
                              atributoCertificadoList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributoCertificadoList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoCertificado.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <br />

      <mat-accordion id="accordionScr" multi>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header
            style="border-bottom: 1px solid #e0e0e1 !important"
          >
            <mat-panel-title>
              <label class="accordion-title">
                <section>
                  <mat-checkbox
                    color="primary"
                    formControlName="chkFinalidadeScr"
                    ngDefaultControl
                    (click)="
                      resetAttributes($event, 'drpMotivoScr');
                      $event.stopPropagation()
                    "
                    id="checkbox-motivos-scr"
                    #showMotivosScr
                    class="example-margin"
                    ><span class="accordion-checkbox-title">
                      <strong
                        >SCR - Sistema de informação de crédito</strong
                      >
                    </span></mat-checkbox
                  >
                </section>
              </label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mt-4">
            <div
              id="divFinalidadeScr"
              ng-model="solicitarRelAnalitico.AtributosScr"
              class="form"
            >
              <div class="description-section row">
                SCR: Sistema de informação de crédito do Banco Central do Brasil
              </div>

              <div class="row">
                <div class="dropdown-section col-lg-6 col-sm-12">
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.chkFinalidadeScr.valid &&
                      form.controls.motivoScr.invalid
                    "
                  >
                    *
                  </div>

                  <mat-form-field
                    style="width: 100%"
                    id="dropdown-motivos-scr"
                    appearance="outline"
                  >
                    <mat-label>Selecione</mat-label>
                    <mat-select
                      id="mselect-atributosScr"
                      #showAtributosScr
                      [disabled]="!form.controls.chkFinalidadeScr.value"
                      (selectionChange)="
                        changeDropList($event, 'drpMotivoScr')
                      "
                    >
                      <mat-option value="" selected>&nbsp;</mat-option>
                      <mat-option
                        [value]="motivoScr"
                        class="multiline-mat-option"
                        *ngFor="let motivoScr of motivoScrList"
                      >
                        {{ motivoScr }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <br />
                </div>

                <div
                  id="AtributosScr"
                  class="clsAtributos attribute-section col-lg-6 col-sm-12"
                  *ngIf="
                    form.controls.motivoScr.valid &&
                    form.controls.chkFinalidadeScr.value
                  "
                >
                  <div class="row">
                    <label
                      class="attribute-checkbox col-lg-6 col-md-12 col-sm-12"
                      formArrayName="chkAtributoScr"
                      *ngFor="
                        let atributoScr of form.get(
                          'chkAtributoScr'
                        )['controls'];
                        let i = index
                      "
                    >
                      <section
                        class="example-section"
                        style="word-wrap: break-word"
                      >
                        <span class="example-list-section">
                          <mat-checkbox
                            [id]="
                              'atributoScr-' +
                              atributoScrList[i].alias
                            "
                            class="example-margin"
                            color="primary"
                            [formControlName]="i"
                          >
                            <span class="text-wrap" style="height: auto">{{
                              atributoScrList[i].alias
                            }}</span>
                          </mat-checkbox>
                        </span>
                      </section>
                    </label>
                  </div>
                  <div
                    style="color: red"
                    *ngIf="
                      missingFieldsAlertActive &&
                      form.controls.hiddenAtributoScr.invalid
                    "
                  >
                    * Selecione ao menos uma das opções
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <br />
    </form>
  </div>
</mat-dialog-content>

<div class="modal-footer">
  <button class="btn btnPadrao" mat-dialog-close [disabled]="submmited">
    <em class="fa fa-times-circle fa-lg mx-2"></em>
    Cancelar
  </button>

  <button
    class="btn btnPadraoAzul"
    (click)="createPedido()"
    [disabled]="submmited"
  >
    <em class="fa fa-save fa-lg mx-2"></em>
    Finalizar solicitação
  </button>
</div>
